<template>
  <div id="menuModal" class="vendor-menu-modal">
    <Suspense><menu-item v-bind="$props" /></Suspense>
  </div>
</template>

<script>
import { DISPLAY } from "@/../app-constants";
import MenuItem from "./menu-item/MenuItem.vue";
import { Suspense } from "vue";
export default {
  name: "VendorMenuModal",
  components: { Suspense, MenuItem },
  props: {
    menuItem: Object,
    instructions: String,
    quantity: Number,
    index: Number,
    isEdit: Boolean
  },
  data() {
    return {
      modal: null
    };
  },
  mounted() {
    const vendorModal = document.getElementsByClassName("v--modal-overlay")[0];
    if (vendorModal) vendorModal.style.minHeight = "unset";

    this.setHeight();
  },
  unmounted() {
    window.removeEventListener("resize", this.updateModalStyle);
  },
  methods: {
    setHeight() {
      if (window.innerWidth <= DISPLAY.minDesktopWidth) {
        this.modal = document.getElementById("menuModal");
        window.addEventListener("resize", this.updateModalStyle);
        this.updateModalStyle();
      }
    },
    updateModalStyle() {
      if (this.modal) this.modal.style.minHeight = `${window.innerHeight}px`;
    }
  }
};
</script>

<style lang="scss">
.dark {
  .vendor-menu-options {
    color: $primary-color;

    &__instruction {
      background-color: $background-dark--1;
    }
  }
}

.vendor-menu-modal {
  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__error-message {
    text-align: center;
    line-height: 150%;
    font-weight: bold;
    text-transform: uppercase;
    color: $error-color;
  }
}

.close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  cursor: pointer;

  &:before,
  &:after {
    position: absolute;
    top: 8px;
    left: 15px;
    content: "";
    height: 15px;
    width: 3px;
    background-color: $text-color;
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
}
</style>
